﻿import { connect } from 'react-redux';
import ConfigureTimeSlots from '../../../components/Admin/ConfigureTimeSlots/ConfigureTimeSlots';
import { getDefaultTimeSlotsPackage, saveTimeSlotsPackage } from '../../../actions/entities/timeSlots';
import { addTimeSlot, editTimeSlot, deleteTimeSlot } from '../../../actions/uiElements/timeSlotConfiguration';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const mapStateToProps = ({ entities: { timeSlots }, global: { auth } }) => {
  const access = auth.featureAccessList;
  const { isFetching, timeSlotPackage, validationMessage } = timeSlots.defaultPackage;
  return {
    isFetching,
    defaultTimeSlotPackage: timeSlotPackage,
    validationMessage,
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
  };
};

const mapDispatchToProps = dispatch => ({
  getDefaultTimeSlotsPackage: async () => await dispatch(getDefaultTimeSlotsPackage()),
  addTimeSlot: newTimeSlot => dispatch(addTimeSlot(newTimeSlot)),
  editTimeSlot: timeSlotToEdit => dispatch(editTimeSlot(timeSlotToEdit)),
  deleteTimeSlot: timeSlotName => dispatch(deleteTimeSlot(timeSlotName)),
  save: timeSlots => dispatch(saveTimeSlotsPackage(timeSlots)),
});

const ConfigureTimeSlotsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigureTimeSlots);

export default ConfigureTimeSlotsContainer;
